import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';

import VoucherBox from 'Components/Vouchers/VoucherBox';
import VoucherDeliveryBox from 'Components/Vouchers/VoucherDeliveryBox';

function SiteCoupons({ vouchers, deliveries, appliedVoucher }) {
  return (
    <article className="account-table site-coupons">
      <h2 className="account-table-heading">
        <FormattedMessage id="account-site-coupons.title" defaultMessage="Coupons" />
      </h2>
      {isEmpty(vouchers) && isEmpty(deliveries) &&
        <div className="account-table-row">
          <p className="mb-0">
            <FormattedMessage id="account-site-coupons.no-vouchers" defaultMessage="Sorry - There are currently no available coupons." />
          </p>
        </div>
      }
      {!isEmpty(vouchers) && vouchers.map(voucher =>
        <VoucherBox
          accountVoucher
          voucher={voucher}
          key={voucher._id}
          appliedVoucher={appliedVoucher}
        />,
      )}
      {!isEmpty(deliveries) && deliveries.map(delivery =>
        <VoucherDeliveryBox
          accountVoucher
          delivery={delivery}
          key={delivery._id}
        />,
      )}
    </article>
  );
}

SiteCoupons.propTypes = {
  vouchers: PropTypes.arrayOf(PropTypes.shape({})),
  deliveries: PropTypes.arrayOf(PropTypes.shape({})),
  appliedVoucher: PropTypes.shape({}),
};

SiteCoupons.defaultProps = {
  vouchers: [],
  deliveries: [],
  appliedVoucher: {},
};

const mapStateToProps = ({
  vouchers: { all: vouchersAll },
  deliveries: { all: deliveriesAll },
  voucher,
}) => ({
  vouchers: vouchersAll,
  deliveries: deliveriesAll,
  voucher,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SiteCoupons);
